import { render, staticRenderFns } from "./MetaTemplateMessageSelector.vue?vue&type=template&id=0dd27252&scoped=true"
import script from "./MetaTemplateMessageSelector.vue?vue&type=script&lang=js"
export * from "./MetaTemplateMessageSelector.vue?vue&type=script&lang=js"
import style0 from "./MetaTemplateMessageSelector.vue?vue&type=style&index=0&id=0dd27252&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd27252",
  null
  
)

export default component.exports